<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Doctor Lead</label>
</div>
<div class="col-md-12 mt-4">
  <div class="row col-md-12 justify-content-end mb-2">
    <button class="btn btn-success button" (click)="exportAsXLSX()"><em class="fa fa-share"
        *ngIf="isEditEnabled"></em>&nbsp;&nbsp;&nbsp;
      Export to Excel</button>
  </div>
  <div class="table-responsive pl-10 pr-10">
    <table class="table table-hover table-bordered">
      <thead class="turTable">
        <tr class="">
          <th class="cellHeader">Doctor Name</th>
          <th class="cellHeader">Clinic Name</th>
          <th class="cellHeader">Email ID</th>
          <th class="cellHeader">Status</th>
          <th class="cellHeader">Phone No.</th>
          <th class="cellHeader">Converted At</th>
          <th class="cellHeader">Converted By</th>
          <th class="cellHeader action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of doctorLeadList">
          <td class="cellValue">{{item?.first_name}} {{item?.last_name}}</td>
          <td class="cellValue">{{item?.clinic_name}}</td>
          <td class="cellValue">{{item?.email_id}}</td>
          <td class="cellValue">{{item?.status}}</td>
          <td class="cellValue">{{item?.phone_no}}</td>
          <td class="cellValue">{{item?.converted_at | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue">{{item?.converted_by?.name}}</td>
          <td class="cellValue text-center">
            <button class="invoiceTur btn" (click)="viewLead(item)">View</button>
            <button class="payBlue btn" (click)="editLead(item)"
              *ngIf="isEditEnabled && item.status !== 'APPROVED' && item.status !== 'REJECTED'">Edit</button>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent($event)">
  </mat-paginator>

</div>
